/**
 * Utility functions for user-specific localStorage operations
 * Ensures data isolation between different users sharing the same browser
 */

// Prefix für alle benutzerspezifischen Keys
const getUserKey = (userId: string, key: string) => `user_${userId}_${key}`;

/**
 * Speichert Daten mit Benutzer-Kontext
 */
export const setUserStorage = (userId: string, key: string, value: any) => {
  try {
    localStorage.setItem(getUserKey(userId, key), JSON.stringify(value));
  } catch (error) {
    console.error('Failed to save user storage:', error);
  }
};

/**
 * Lädt Daten mit Benutzer-Kontext
 */
export const getUserStorage = <T>(userId: string, key: string): T | null => {
  try {
    const stored = localStorage.getItem(getUserKey(userId, key));
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Failed to load user storage:', error);
    return null;
  }
};

/**
 * Löscht einen spezifischen benutzerbezogenen Key
 */
export const removeUserStorage = (userId: string, key: string) => {
  try {
    localStorage.removeItem(getUserKey(userId, key));
  } catch (error) {
    console.error('Failed to remove user storage:', error);
  }
};

/**
 * Standard-Keys für die Anwendung
 */
export const USER_STORAGE_KEYS = {
  DASHBOARD_CACHE: 'dashboard_cache',
  PERMISSIONS_CACHE: 'sidebar_permissions',
  CURRENT_SECTION: 'current_section',
  SELECTED_GESELLSCHAFT_ID: 'selected_gesellschaft_id',
  SELECTED_GESELLSCHAFT: 'selected_gesellschaft',
  DOWNLOADCENTER_EXPANDED: 'downloadcenter_expanded',
  PRODUKTANBIETER_ACCORDIONS: 'produktanbieter_accordions',
  PRODUKTANBIETER_TAB: 'produktanbieter_tab',
} as const;
